import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import CopyText from '@saucelabs/sl-component-copy-text';
import { Row, Col } from '@saucelabs/sl-component-grid';
import modalConnect from '@saucelabs/sl-container-modal';
import { Modal } from '@saucelabs/sl-component-overlay';

const VIRTUAL_SESSION_INVITE_MODAL_KEY = 'virtualSessionInvite';

const InviteModal = ({
  jobUrl,
  onHide,
  show,
}) => {
  const [invitationLink, setInvitationLink] = useState(jobUrl);

  useEffect(() => {
    if (show) {
      setInvitationLink(window.location.href);
    }
  }, [show]);

  return (
    <Modal
      onHide={onHide}
      show={show}
    >
      <Modal.Header>
        <Modal.Title>Invite someone to watch this session</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs>
            <CopyText text={invitationLink} />
            <p>
              <i>
                Send this URL to other Sauce users in your organization to enable
                them to observe this session along with you.
              </i>
            </p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          category="default"
          material
          onClick={onHide}
          size="sm"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

InviteModal.propTypes = {
  jobUrl: PropTypes.string,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

InviteModal.defaultProps = {
  jobUrl: '',
};

export default modalConnect(VIRTUAL_SESSION_INVITE_MODAL_KEY, InviteModal);
export {
  InviteModal,
  VIRTUAL_SESSION_INVITE_MODAL_KEY,
};
